import { init } from "./init";
import { sanitizeData, sanitizeExpire } from "./Sanitize";

const actionTypes = {
  FETCH_TRANSACTIONS_DETAILS: "FETCH_TRANSACTIONS_DETAILS"
};

const fetchTransactionsDetails = async (state, transactionsdetails) => {
  state = {
    ...state,
    isStatus: transactionsdetails.status,
    expireToken: sanitizeExpire({
      status: transactionsdetails.status,
      data: transactionsdetails.data,
      name: "transactionsdetailobj"
    }),
    data: sanitizeData({
      status: transactionsdetails.status,
      data: transactionsdetails.data,
      name: "transactionsdetailobj"
    })
  };
  return state;
};

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_TRANSACTIONS_DETAILS:
      return fetchTransactionsDetails(state, action.transactionsdetails);
    default:
      return state;
  }
};

const transactionsdetails = {
  init,
  actionTypes,
  reducer
};

export default transactionsdetails;
